import { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";

export function useDate() {
  const { timezone } = useContext(AuthContext);

  function dateToClient(strDate) {
    if (!strDate) return strDate;
    try {
      const date = new Date(strDate);
      if (isNaN(date.getTime())) return strDate;

      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: timezone
      }).format(date);
    } catch (e) {
      return strDate;
    }
  }

  function datetimeToClient(strDate) {
    if (!strDate) return strDate;
    try {
      const date = new Date(strDate);
      if (isNaN(date.getTime())) return strDate;

      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      }).format(date);
    } catch (e) {
      return strDate;
    }
  }

  // Reescrito sem moment: este hook e usado pelo layout e pelo useAuth, que
  // montam em toda tela, entao o import arrastava moment (61 KB) para o main.js.
  // Nota: dateToDatabase nao tem nenhum chamador no projeto hoje.
  function dateToDatabase(strDate) {
    if (typeof strDate !== "string") return strDate;

    const m = strDate.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!m) return strDate;

    const [, dd, mm, yyyy, hh = "00", mi = "00", ss = "00"] = m;

    // Valida de verdade (rejeita 31/02, por exemplo)
    const probe = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    if (
      probe.getFullYear() !== Number(yyyy) ||
      probe.getMonth() !== Number(mm) - 1 ||
      probe.getDate() !== Number(dd)
    ) {
      return strDate;
    }

    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  }

  function returnDays(date) {
    let data1 = new Date()
    let data2 = new Date(date)
    let result = data2.getTime() - data1.getTime();
    let days = Math.ceil(result / (1000 * 60 * 60 * 24));

    if (days === -0) {
      days = 0
    }
    return days;
  }

  return {
    dateToClient,
    datetimeToClient,
    dateToDatabase,
    returnDays
  };
}
